/**
 * Carrot Graph dates are in seconds, JS dates are milliseconds
 * @param str
 * @return {number}
 */
export const dateFloat = (str) =>
  (str ? new Date(str) : new Date()).valueOf() / 1000
